import React from "react";
import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/common/app-sidebar";
import { UnifiedHeader } from "@/components/common/unified-header";
import { useNavigation } from "@/hooks/use-navigation";
import getConfig from "@/configuration";
import { ActivityDeactivateBlockedDialogHost } from "@/features/work-order-activity/components/activity-deactivate-blocked-dialog-host";

export const AppLayout: React.FC = () => {
  const { currentModule, setCurrentModule } = useNavigation();

  return (
    <SidebarProvider className="min-h-0 flex-1">
      <AppSidebar
        currentModule={currentModule}
        onModuleChange={setCurrentModule}
      />
      <SidebarInset>
        <UnifiedHeader />
        <main className="flex-1 py-2 px-2 sm:py-4 sm:px-4 w-full min-w-0 overflow-hidden">
          <div className="w-full space-y-3 sm:space-y-4 min-w-0">
            <Outlet />
          </div>
        </main>
        <ActivityDeactivateBlockedDialogHost />
        <footer className="shrink-0">
          <p className="text-[10px] leading-none text-gray-400 text-end px-4 py-1.5 sm:px-6">
            {getConfig().appName} v1.0.0
          </p>
        </footer>
      </SidebarInset>
    </SidebarProvider>
  );
};
